<template>
  <div>
    <!--    新闻中心-->
    <div class="innews">
      <div class="content">
        <div class="lmtit">新闻中心</div>
        <div class="lmxian"></div>
        <div class="lmjj">每一个客户的认可都是对中科智充的鼓励</div>
        <div class="nr">
          <router-link to="">
            <div class="left" :v-model="article">
              <div class="pic">
                <el-image v-if="article.img" @error.once="error(article)" fit="contain" :src="article.img">
                </el-image>
              </div>
              <div class="tit">
                {{ article.title }}
                <div @click="openNewPage(article)" class="more">查看详情</div>
              </div>
            </div>
          </router-link>
          <div class="innewsnr">
            <div class="hd">
              <ul>
                <li>公司新闻</li>
                <li>行业动态</li>
                <li>其他资讯</li>

                <div class="clean"></div>
              </ul>
            </div>
            <div class="bd">
              <ul>
                <router-link to="/news" v-if="index<4" v-for="(item,index) in articles" :key="index">
                  <li>{{ item.title }}
                    <div class="date">{{ item.date|formatDate }}</div>
                  </li>
                </router-link>
                <router-link to="/news" class="more">查看更多+</router-link>
              </ul>
            </div>
          </div>
          <div class="clean"></div>
        </div>
      </div>
    </div>

    <div class="inlink">
      <div class="container">
        <div v-if="isShow" class="map">
          <Maps/>
        </div>
        <div class="content">
          <div class="lmtit"><i class="fa fa-link"></i>合作伙伴</div>
          <div class="nr">
            <el-link @click="redirect(item)" v-for="(item,index) in partners" :key="index" type="primary">
              <el-image fit="contain" :src="item.image"/>
            </el-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { NewsMixin } from '../../mixins/NewsMixin'
import Maps from '../news/Maps'

export default {
  name: 'News',
  mixins: [NewsMixin],
  components: {
    Maps
  },
  created () {
    this.getArticles()
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  },
  data () {
    return {
      isShow: true,
      partners: [
        {
          image: require('../../assets/images/footer/中国电建.jpg'),
          url: 'https://www.powerchina.cn/'
        },
        {
          image: require('../../assets/images/footer/国家电投.jpg'),
          url: 'http://www.spic.com.cn/xxgk2/gkml/jtgg/'
        },
        {
          image: require('../../assets/images/footer/国家电网.png'),
          url: 'http://www.sgcc.com.cn/'
        },
        {
          image: require('../../assets/images/footer/大唐环境.jpg'),
          url: 'https://dtfn.dlzbxx.com/'
        },
        {
          image: require('../../assets/images/footer/怀化城投.png'),
          url: 'http://www.hhcjt.cn/hhcjt/'
        },
        {
          image: require('../../assets/images/footer/湖南六建.png'),
          url: 'http://www.hn6jcg.com/'
        },
        {
          image: require('../../assets/images/footer/湖南建工.jpg'),
          url: 'http://www.chceg.com/?security_verify_data=313630302c393030'
        },
        {
          image: require('../../assets/images/footer/湖南轨道.png'),
          url: 'http://www.hngdkg.com/'
        },
        {
          image: require('../../assets/images/footer/金风科技.jpg'),
          url: 'https://www.goldwind.com/cn/'
        },
        {
          image: require('../../assets/images/footer/滴灌通.png'),
          url: 'https://microconnect.com/'
        }
      ]
    }
  },
  methods: {
    redirect (item) {
      window.location.href = item.url
    },
    handleResize () {
      let fullWidth = document.documentElement.clientWidth
      if (fullWidth > 788) {
        this.isShow = true
      } else {
        this.isShow = false
      }
    },
    load (event) {
      console.log('加载成功：', event)
    },
    error (item, event) {
      console.log('加载失败：', item, event)
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/css/style.css";
@import "../../assets/css/reset.css";
@import "../../assets/css/media.css";

.inlink {
  padding: 20px 0;
  background: #f5f5f5;
  display: flex;
  justify-content: center;

  .container {
    display: flex;
    flex-direction: row;
    width: 70%;
    justify-content: center;

    .map {
      float: left;
      width: 1000px;
      height: 450px;
    }

    .content {
      width: 100%;
      margin: 5px 5px 5px 5px;
      border: 1px solid white;

      .lmtit {
        margin: 5px 0 10px 0;
        text-align: center;
        font-size: 16px;
        font-weight: bold;
        color: #333;
      }

      .nr {
        align-items: center;
        text-align: center;
        justify-content: center;
        max-height: 400px;
        overflow: scroll;

        &::-webkit-scrollbar {
          display: none
        }

        .el-link {
          //background-color: black;
          max-height: 92px;
          max-width: 214px;
          border-radius: 5px;
          margin: 20px 20px;
          font-size: 14px;
        }
      }
    }
  }
}

.innews .left img {
  width: 100%;
  height: auto;
  transition: all .5s;
}

.innews .innewsnr .bd ul li {
  height: 20px;
  line-height: 20px;
  border-bottom: 1px solid #dfdfdf;
  font-size: 14px;
  display: block;
  padding: 0 70px 0 0;
  position: relative;
  margin-top: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.innews .innewsnr .bd ul li .date {
  position: absolute;
  width: 50px;
  text-align: right;
  font-size: 12px;
  right: 3%;
  top: 0;
}
</style>
